// ─── src/types/stats.ts ───────────────────────────────────────────────────────

/** Raw count entry returned by the stats endpoints */
export interface CountEntry {
  name:  string;
  count: number;
}

/** Chart-ready entry (percentage added client-side) */
export interface ChartEntry {
  name:       string;
  value:      number;
  percentage: string;
}

export interface RegistrationStatsResponse {
  total:                 number;
  pitchingIdea:          number;
  requestingScholarship: number;
  availableAllDays:      number;
  byCity:      CountEntry[];
  byGender:    CountEntry[];
  byIdeaTheme: CountEntry[];
}

export interface MentorStatsResponse {
  total:    number;
  online:   number;
  onsite:   number;
  onDemand: number;
  byTopic:     CountEntry[];
  byCity:      CountEntry[];
  byFrequency: CountEntry[];
  byMode:      CountEntry[];
}

/** Convert CountEntry[] → ChartEntry[] by computing percentage against a total */
export const toChartEntries = (entries: CountEntry[], total: number): ChartEntry[] =>
  entries.map((e) => ({
    name:       e.name,
    value:      e.count,
    percentage: total > 0 ? ((e.count / total) * 100).toFixed(1) : "0",
  }));
